export enum VARIANT {
  JACKS_OR_BETTER = "Jacks or better",
  DEUCES_WILD = "Deuces wild",
  NONE = "None",
}

export enum N_HANDS {
  ONE = 1,
  THREE = 3,
  FIVE = 5,
  TEN = 10,
  TWENTY_FIVE = 25,
  FIFTY = 50,
  ONE_HUNDRED = 100,
  FIVE_HUNDRED = 500,
  ONE_THOUSAND = 1000,
}
